export const TestIds = {
  FeedTitle: "FeedTitle",
  FeedCompoTitle: "FeedCompoTitle",

  // Auth
  LoginUsernameInput: "LoginUsernameInput",
  LoginPasswordInput: "LoginPasswordInput",
  LoginSubmit: "LoginSubmit",
  RegisterUsernameInput: "RegisterUsernameInput",
  RegisterPasswordInput: "RegisterPasswordInput",
  RegisterEmailInput: "RegisterEmailInput",
  RegisterInvitedByInput: "RegisterInvitedByInput",
  RegisterSubmit: "RegisterSubmit",
  ForgotPasswordEmailInput: "ForgotPasswordEmailInput",
  ForgotPasswordSubmit: "ForgotPasswordSubmit",
  ResetPasswordInput: "ResetPasswordInput",
  ResetPasswordConfirmInput: "ResetPasswordConfirmInput",
  ResetPasswordSubmit: "ResetPasswordSubmit",

  // Navigation / chrome
  ToolbarUserSummary: "ToolbarUserSummary",
  PlaybackToolbar: "PlaybackToolbar",
  SearchInput: "SearchInput",
  SearchResults: "SearchResults",
  ErrorDisplay: "ErrorDisplay",
  SiteFooter: "SiteFooter",

  // Entry view
  EntryTitleHeading: "EntryTitleHeading",
  EntryLikeButton: "EntryLikeButton",
  EntryLikeCount: "EntryLikeCount",

  // Feed
  FeedTitleContainer: "FeedTitleContainer",

  // Admin / compos
  AdminGenerateVotesLink: "AdminGenerateVotesLink",
  AdminVotesRequiredLink: "AdminVotesRequiredLink",
  AdminBadVotersLink: "AdminBadVotersLink",
  AdminGenerateVotesSuccess: "AdminGenerateVotesSuccess",
  VotesRequiredEmpty: "VotesRequiredEmpty",
  VotesRequiredTable: "VotesRequiredTable",

  // Compo admin
  HideImagesBeforeCompoStartCheckbox: "HideImagesBeforeCompoStartCheckbox",
  CompoSettingsSaveButton: "CompoSettingsSaveButton",

  // Compo creation
  InputCompoName: "InputCompoName",
  InputThemeShort: "InputThemeShort",
  InputThemeDescription: "InputThemeDescription",
  DateInputStart: "DateInputStart",
  DateInputStop: "DateInputStop",
  DateInputJudgingStop: "DateInputJudgingStop",
  InputPrimaryImage: "InputPrimaryImage",
  InputHeaderImage: "InputHeaderImage",
  SubmitNewCompo: "SubmitNewCompo",

  // Entry submission
  EntryTitleInput: "EntryTitleInput",
  EntryDescriptionInput: "EntryDescriptionInput",
  EntryTagsInput: "EntryTagsInput",
  EntryTypeStory: "EntryTypeStory",
  EntrySubmitButton: "EntrySubmitButton",
  CollaboratorInput: "CollaboratorInput",

  // Entry edit
  UpdateEntryButton: "UpdateEntryButton",
  UpdateEntrySaved: "UpdateEntrySaved",
  CollaboratorConfirmed: "CollaboratorConfirmed",
  CollaboratorPending: "CollaboratorPending",

  // Notifications
  CollabAcceptButton: "CollabAcceptButton",
  CollabRejectButton: "CollabRejectButton",
  CollabRequestNotification: "CollabRequestNotification",

  // Upcoming cards
  UpcomingCardHover: "UpcomingCardHover",
  UpcomingSection: "UpcomingSection",

  // Feed
  FeedContent: "FeedContent",
  FeedCard: "FeedCard",

  // Theme
  ThemeToggleButton: "ThemeToggleButton",

  // Event creation
  EventTitleInput: "EventTitleInput",
  EventDescriptionInput: "EventDescriptionInput",
  EventUrlInput: "EventUrlInput",
  EventStartInput: "EventStartInput",
  EventImageInput: "EventImageInput",
  EventSubmitButton: "EventSubmitButton",

  // Event edit
  EditEventTitleInput: "EditEventTitleInput",
  EditEventStartInput: "EditEventStartInput",
  EditEventSubmitButton: "EditEventSubmitButton",

  // Feed event cards
  FeedEventCard: "FeedEventCard",

  // Comments
  PostAnonymouslyCheckbox: "PostAnonymouslyCheckbox",

  // Judge page
  JudgeListCard: "JudgeListCard",
  JudgeListCardTitle: "JudgeListCardTitle",
  JudgeListCardCheckmark: "JudgeListCardCheckmark",
  JudgeVoteSubmitButton: "JudgeVoteSubmitButton",

  // Sync listen page
  SyncListenPage: "SyncListenPage",
  SyncListenStartButton: "SyncListenStartButton",
  SyncListenPauseButton: "SyncListenPauseButton",
  SyncListenConnectionStatus: "SyncListenConnectionStatus",
  SyncListenTracklistItem: "SyncListenTracklistItem",
  SyncListenNextButton: "SyncListenNextButton",
} as const;

export type TestId = (typeof TestIds)[keyof typeof TestIds];
